import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB-R68bHborIyFoQMrxO9jeWsMCZFhyy0Q",
  authDomain: "empowerher2025-1881a.firebaseapp.com",
  projectId: "empowerher2025-1881a",
  storageBucket: "empowerher2025-1881a.firebasestorage.app",
  messagingSenderId: "376134841866",
  appId: "1:376134841866:web:d0d386f6501d237bd791f3"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
